// Please do not add any code here!!!!!!
// All the UI and React hooks api should be added outside of mca-core.

import _ from 'underscore';
import { useContext, useMemo } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import CryptoJS from 'crypto-js';

import { isProdEnvironment } from '../get-environment';
import {
  UpSignupWizardCouponClassForProd,
  UpSignupWizardCouponClassForNonProd,
  UpSignupWizardCouponDetails,
} from '../constants';
import { getIsSpamEmail } from '../helpers';

export function useBackupCoupon() {
  const isProd = isProdEnvironment(window.location.host);

  const backupCouponClass = useMemo(() => (
    isProd ? UpSignupWizardCouponClassForProd : UpSignupWizardCouponClassForNonProd
  ), [isProd]);

  const backupCouponDetailsConstant = useMemo(() => (
    UpSignupWizardCouponDetails[backupCouponClass]
  ), [backupCouponClass]);

  return {
    backupCouponClass,
    backupCouponDetailsConstant,
  };
}

export function useHashedEmail() {
  const serverContext = useContext(ServerContext);
  const email = _.get(serverContext, ['CurrentUser', 'Email']) || _.get(serverContext, ['Identity', 'Email']) || '';
  const isSpamEmail = getIsSpamEmail(email);
  const hashedEmail = CryptoJS.MD5(email).toString();
  return { isSpamEmail, hashedEmail };
}

export function useCampaignIdFromScope() {
  const { scope } = useContext(ScopeContext);

  const campaignId = _.get(scope, ['values', 'campaignId']);
  return campaignId && `${campaignId}`;
}

// Please do not add any code here!!!!!!
// All the UI and React hooks api should be added outside of mca-core.
